// extracted by mini-css-extract-plugin
export default {"detailsBtn":"ExchangeRowBig_detailsBtn__Es2ES"};